// Latest app versions
export const LATEST_VERSIONS = {
  Android: "12.1.0",
  iOS: "3.1.0",
};

// App Store URLs
export const APP_STORE_URLS = {
  Android: "https://play.google.com/store/apps/details?id=ai.mple.dev_app.twa",
  iOS: "https://apps.apple.com/in/app/mple-ai/id6739861547",
};

// Check interval (7 days in milliseconds)
export const CHECK_INTERVAL = 7 * 24 * 60 * 60 * 1000;
